import { Moment } from 'moment';

import * as Api from '../api/api';

const ContactRoutes = {
  getBaseRoute: (contactId?: number, route?: string) =>
    `/contact/${contactId || ':contactId'}${route || ''}`,

  getScheduledMessageRoute: (scheduledMessageId?: number) =>
    `/scheduled-text-message/${scheduledMessageId || ':scheduledMessageId'}`,
  updateMessage: (messageId: number) => `/messages/${messageId}`,
};

class Contact {
  contactId: number;

  constructor(contactId: number) {
    this.contactId = contactId;
  }

  route(uri: string) {
    return `${ContactRoutes.getBaseRoute(this.contactId)}${uri}`;
  }

  sendText = async (
    message: string,
    messageType: string,
    context: ContactContextType,
    subject?: string | null,
    sendDateTime?: Moment | null,
    urlMappings?: Record<string, string>,
    sendVCardForOrgId?: number,
  ) =>
    Api.post(this.route('/messages'), {
      body: JSON.stringify({
        message,
        messageType,
        context,
        subject,
        sendDateTime,
        urlMappings,
        sendVCardForOrgId,
      }),
    });

  getMessages = async () => Api.get(this.route('/messages'));

  getCalls = async () => Api.get(this.route('/calls'));

  updateMessage = (messageId: number, context: ContactContextType, update: Partial<Message>) =>
    Api.post(this.route(ContactRoutes.updateMessage(messageId)), {
      body: JSON.stringify({ context, update }),
    });

  updateScheduledMessage = (scheduledMessageId: number, update: Record<string, any>) =>
    Api.post(this.route(ContactRoutes.getScheduledMessageRoute(scheduledMessageId)), {
      body: JSON.stringify(update),
    });

  cancelScheduledText = (scheduledMessageId: number) =>
    Api.del(this.route(ContactRoutes.getScheduledMessageRoute(scheduledMessageId)));

  makeCall = (userPhoneNumber: string, useAsDefault: boolean, context: ContactContextType) =>
    Api.post(this.route('/calls'), {
      body: JSON.stringify({
        userPhoneNumber,
        useAsDefault,
        context,
      }),
    });

  static sendBulkText = (
    contacts: Array<{ contactId: number; context: ContactContextType }>,
    messageBody: string,
    messageType: string,
    hasVCardAttached: boolean,
    subject?: string | null,
    sendDateTime?: Moment | null,
    urlMappings?: Record<string, string>,
  ) =>
    Api.post('/contact/bulk-message', {
      body: JSON.stringify({
        contacts,
        messageBody,
        messageType,
        subject,
        sendDateTime,
        urlMappings,
        hasVCardAttached,
      }),
    });
}

export default Contact;
